// Manifest reader — typed access to each manifest + legacy ↔ microSkill
// helpers. Phase B §B4.

import type {
  ManifestName,
  ManifestForName,
  LegacySkillIdMap,
} from "../types/manifests";

import microSkills from "../data/manifests/microSkills.json";
import legacySkillIdMap from "../data/manifests/legacySkillIdMap.json";
import learningProgressions from "../data/manifests/learningProgressions.json";
import supportModeGatingRules from "../data/manifests/supportModeGatingRules.json";
import spacedReviewSchedule from "../data/manifests/spacedReviewSchedule.json";
import transferTasks from "../data/manifests/transferTasks.json";
import misconceptionInterventions from "../data/manifests/misconceptionInterventions.json";
import placementAssessmentBlueprint from "../data/manifests/placementAssessmentBlueprint.json";
import progressMonitoringBlueprint from "../data/manifests/progressMonitoringBlueprint.json";
import sessionDesignRules from "../data/manifests/sessionDesignRules.json";
import accelerationRules from "../data/manifests/accelerationRules.json";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MANIFEST_DATA: Record<ManifestName, any> = {
  microSkills,
  legacySkillIdMap,
  learningProgressions,
  supportModeGatingRules,
  spacedReviewSchedule,
  transferTasks,
  misconceptionInterventions,
  placementAssessmentBlueprint,
  progressMonitoringBlueprint,
  sessionDesignRules,
  accelerationRules,
};

export function getManifest<M extends ManifestName>(name: M): ManifestForName<M> {
  return MANIFEST_DATA[name] as ManifestForName<M>;
}

const LEGACY_MAP = legacySkillIdMap as unknown as LegacySkillIdMap;

/** legacy module id → microSkill id (e.g. "math.07" → "ms.math.07"). */
export function lookupMicroSkillForLegacy(legacyId: string): string | null {
  return LEGACY_MAP.legacy_to_microskill[legacyId] ?? null;
}

/** microSkill id → legacy module ids (array; one-to-many possible). */
export function mapMicroSkillIdToLegacy(microSkillId: string): string[] {
  return LEGACY_MAP.microskill_to_legacy[microSkillId] ?? [];
}
